const SearchIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="19"
    height="18"
    fill="none"
    viewBox="0 0 19 18"
  >
    <path
      stroke="#585F74"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.5"
      d="M9.425 15.75a7.125 7.125 0 1 0 0-14.25 7.125 7.125 0 0 0 0 14.25M17.3 16.5 15.8 15"
    />
  </svg>
);

export default SearchIcon;